import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ExpiredCardInfoWrapper = styled.div`
  margin-bottom: ${Spacing.S8};
`
